"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var executor_native_exports = {};
__export(executor_native_exports, {
  createWorkletExecutor: () => createWorkletExecutor
});
module.exports = __toCommonJS(executor_native_exports);
var import_react_native_worklets = require("react-native-worklets");
var runtime = null;
var queue = Promise.resolve();
function createWorkletExecutor(calculate) {
  var disposed = false;
  return {
    execute(request, isCurrent) {
      var job = queue.then(async function() {
        if (disposed || !isCurrent(request.revision)) return null;
        runtime !== null && runtime !== void 0 ? runtime : runtime = (0, import_react_native_worklets.createWorkletRuntime)({
          name: "one-background"
        });
        var value = await (0, import_react_native_worklets.runOnRuntimeAsync)(runtime, function(input) {
          "worklet";
          var result = calculate(input);
          if (result instanceof Promise) throw new TypeError("background computations must be synchronous");
          return result;
        }, request.input);
        return {
          revision: request.revision,
          value
        };
      });
      queue = job.then(function() {
        return void 0;
      }, function() {
        return void 0;
      });
      return job;
    },
    dispose() {
      disposed = true;
    }
  };
}
//# sourceMappingURL=executor.native.js.map
